import { useState } from 'react'
import Button from '../components/Button/Button.js'
import Modal from '../components/Modal/Modal.js'
import GoogleMapsIframe from '../components/GoogleMapsIFrame.js'
import { CONTACT_DETAILS } from '../constants/site.js'

const contactFields = [
  { name: 'name', label: 'Name', type: 'text' },
  { name: 'phoneNumber', label: 'Phone Number', type: 'text' },
  { name: 'email', label: 'Email', type: 'email' },
]

const formControlClasses =
  'mt-2 block w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-base text-neutral-brand outline-none transition focus:border-teal-primary focus:ring-2 focus:ring-teal-primary/20'

function Contact() {
  const [formValues, setFormValues] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    message: '',
  })
  const [warningMessage, setWarningMessage] = useState('')
  const [result, setResult] = useState('Form not submitted yet.')
  const [showModal, setShowModal] = useState(false)

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormValues((prev) => ({ ...prev, [name]: value }))
  }

  const onSubmit = async (event) => {
    event.preventDefault()
    const emptyFields = Object.entries(formValues).filter(([_, value]) => !value)
    if (emptyFields.length > 0) {
      setWarningMessage(`Please fill in the following fields: ${emptyFields.map(([key]) => key).join(', ')}`)
      return
    }

    setResult('Sending....')
    const formData = new FormData(event.target)
    formData.append('access_key', process.env.REACT_APP_WEB3FORMS_ACCESS_KEY)
    formData.append('subject', `New inquiry from ${formValues.name} - Lakes Osteopathy`)
    formData.append(
      'message',
      ` 
      ${formValues.message}
    `
    )

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
      })
      const data = await response.json()

      if (data.success) {
        setResult(
          <div>
            <p>Thank you for contacting Lakes Osteopathy!</p>
            <br />
            <p>We appreciate your interest and will get back to you as soon as possible.</p>
            <br />
            <p>If you need immediate assistance, please call us directly at 022 095 9334 or 027 238 8222.</p>
          </div>
        )
        event.target.reset()
        setShowModal(true)
        setFormValues({
          name: '',
          phoneNumber: '',
          email: '',
          message: '',
        })
        setWarningMessage('')
      } else {
        console.log('Error', data)
        setResult(data.message)
      }
    } catch (error) {
      console.error('Error submitting form:', error)
      setResult('An error occurred. Please try again.')
    }
  }

  return (
    <main className='container mb-4 lg:mb-30'>
      <h1 className='mb-10 font-serif text-5xl font-bold text-blue-dark'>Contact us</h1>
      <div className='mb-5 flex flex-col-reverse gap-8 lg:grid lg:grid-cols-2'>
        <ContactForm
          formValues={formValues}
          handleChange={handleChange}
          onSubmit={onSubmit}
          warningMessage={warningMessage}
        />
        <ContactInfo />
      </div>
      {showModal && <Modal handleClose={() => setShowModal(false)} message={result} />}
    </main>
  )
}

const ContactForm = ({ formValues, handleChange, onSubmit, warningMessage }) => (
  <form className='mb-4 lg:mb-0 lg:pr-[43.5px]' onSubmit={onSubmit}>
    <div className='grid gap-4'>
      {contactFields.map((field) => (
        <div key={field.name}>
          <label htmlFor={field.name} className='block'>
            {field.label}
          </label>
          <input
            type={field.type}
            name={field.name}
            className={formControlClasses}
            id={field.name}
            value={formValues[field.name]}
            onChange={handleChange}
          />
        </div>
      ))}
      <div className='mb-3'>
        <label htmlFor='message' className='block'>
          Your message
        </label>
        <textarea
          className={formControlClasses}
          name='message'
          id='message'
          rows='3'
          value={formValues.message}
          onChange={handleChange}
        ></textarea>
      </div>
      <div className='flex flex-col gap-3 sm:flex-row sm:items-center'>
        <Button type='submit' label='SEND MESSAGE' buttonType='primary-light' />
        {warningMessage && (
          <div className='rounded border border-amber-300 bg-amber-100 px-4 py-3 text-amber-900' role='alert'>
            {warningMessage}
          </div>
        )}
      </div>
    </div>
  </form>
)

const ContactInfo = () => {
  const { address, phoneNumbers } = CONTACT_DETAILS

  return (
    <div className='lg:pl-[43.5px]'>
      <div className='mb-5 flex flex-col md:flex-row'>
        <div className='mb-4 md:mb-0 md:mr-20'>
          <h2 className='text-lg font-semibold'>CONTACT NUMBER</h2>
          {phoneNumbers.map((phoneNumber) => (
            <p key={phoneNumber.label}>
              {phoneNumber.label}: {phoneNumber.number}
            </p>
          ))}
        </div>
        <div>
          <h2 className='text-lg font-semibold'>PHYSICAL ADDRESS</h2>
          <p>{address.location}</p>
          <p>{address.street}</p>
          <p>{address.city}</p>
        </div>
      </div>
      <div className='aspect-[4/3]'>
        <GoogleMapsIframe />
      </div>
    </div>
  )
}

export default Contact
